export enum Cpf {
    CPF_QTD_DIGITS = 11,
    CPF_QTD_DIGITS_VALIDATOR = 2,
}
